<mat-chip-listbox>
  <mat-chip *ngFor="let gest of formModel.gestionnaires_obj" removable>
    <span>{{gest.role.individu.last_name}} {{gest.role.individu.first_name}} ({{gest.role.individu.uid}})</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="deleteFormGestionnaire(gest.role.individu.uid, formModel.uuid)" *ngIf="canDelete">
      <mat-icon class="mat-16" data-cy="icon-gestionnaires-list-close">close</mat-icon>
    </button>
  </mat-chip>
</mat-chip-listbox>
